import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Stack,
  Paper,
  Divider,
  Button,
  CircularProgress,
  IconButton // Added for a close/back button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Added for the back button icon

const ReceivedRequestDetail = ({ request, onAccept, onDeny, onBack }) => {

  console.log('Loaded request?', request)

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAccept = async () => {
    setLoading(true);
    setError(null);
    try {
      await onAccept(request);
    } catch (err) {
      setError('Failed to accept invitation. Please try again.');
      console.error('Error accepting invitation:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeny = async () => {
    setLoading(true);
    setError(null);
    try {
      await onDeny(request);
    } catch (err) {
      setError('Failed to deny invitation. Please try again.');
      console.error('Error denying invitation:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!request) {
    return (
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, mt: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="error">
            No invitation request selected.
          </Typography>
          <Button
            variant="outlined"
            onClick={onBack}
            sx={{ mt: 2 }}
            startIcon={<ArrowBackIcon />}
          >
            Go Back
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Paper elevation={4} sx={{ p: 4, pt: 2, mt: 4, borderRadius: '12px' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {request.type === 'user-to-join-group' ? `Invitación a entrar en ${request.groupName}` : `Invitación para tocar en vivo`}
          </Typography>
          <IconButton onClick={onBack} color="info" aria-label="go back">
            <ArrowBackIcon />
          </IconButton>
        </Stack>

        <Divider sx={{ mb: 3 }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            {request.type === 'user-to-join-group' ? 'Un grupo ha solicitado que te unas a ellos' : `Tu grupo ${request.dest} está invitado al ${request.activityTitle}`}
          </Typography>
          <Typography variant="h5" color="text.primary" fontWeight="medium" gutterBottom>
            {request.groupName}
          </Typography>
          <Typography variant="body2" color="text.disabled">
            Received on: {new Date(request.date).toLocaleDateString()}
          </Typography>
        </Box>

        {error && (
          <Typography color="error" variant="body2" sx={{ mb: 2, textAlign: 'center' }}>
            {error}
          </Typography>
        )}

        <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="success"
            onClick={handleAccept}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            sx={{ minWidth: 120 }}
          >
            {loading ? 'Accepting...' : 'Accept'}
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={handleDeny}
            disabled={loading}
            sx={{ minWidth: 120 }}
          >
            Deny
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default ReceivedRequestDetail;